module.exports = __webpack_public_path__ + "img/wedding-wire-24.0e9d2b1d.png";